import { sentry } from '@/plugins/sentry';

/**
 * Triggers tagmanager data layer events
 * @see {@link https://www.notion.so/clicksign/3fbb112577ce46f9b9f2851935fc252a?v=3a9fcbc97ada4a7a8350d1082c75da01 Tabela de eventos}
 * @param {string} event - The event name
 * @param {object} payload - Additional event configuration (optional)
 * */
export function triggerDataLayerEvent(event, payload = {}) {
  try {
    if (!window.dataLayer) return;
    window.dataLayer.push({ event, ...payload });
  } catch (err) {
    sentry.captureException(err);
  }
}
